import { makeStyles } from '@material-ui/core';

export const getFillLoaderStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    height: '100%',
    background: theme.palette.background.paper,
  },
}));
